import uniqid from "uniqid";
import { useNavigate } from "react-router-dom";

import { useTabIndex } from "../../contexts/tabIndexContext";
import { useEffect } from "react";

import Reservation from "../../assets/icon/reservation.svg";
import Member from "../../assets/icon/member.svg";
import Message from "../../assets/icon/message.svg";
import Announcement from "../../assets/icon/announcement.svg";
import Problem from "../../assets/icon/problem.svg";
import SystemLog from "../../assets/icon/system-log.svg";
import Car from "../../assets/icon/car.svg";
import Contract from "../../assets/icon/contract.svg";
import House from "../../assets/icon/house.svg";

const Sidebar = () => {
  const { tabIndex, setTabIndex } = useTabIndex();
  const navigate = useNavigate();

  class Option {
    constructor(text, icon, link) {
      this.text = text;
      this.icon = icon;
      this.link = link;
    }
  }

  const options = [
    new Option("預約管理", Reservation, "/reservations"),
    new Option("會員管理", Member, "/members"),
    new Option("租約管理", Contract, "/contract"),
    new Option("車位管理", Car, "/parking"),
    new Option("房源管理", House, "/room"),
    new Option("訊息管理", Message, "/messages"),
    new Option("公佈欄", Announcement, "/announcement"),
    new Option("問題管理", Problem, "/problems"),
    new Option("系統日誌", SystemLog, "/system-log"),
  ];

  const switchTab = (link, index) => {
    navigate(link);
    setTabIndex(index);
  };

  /*
  this is for "return to last page"
  When returning from B to A, the content became "A", but the index isn't updated
  */
  useEffect(() => {
    let inSidebarTab = false;
    options.forEach((option, index) => {
      if (window.location.pathname === option.link) {
        setTabIndex(index);
        inSidebarTab = true;
      }
    });

    if (!inSidebarTab) {
      setTabIndex(-1);
    }
  }, []);

  // NOTE: if tab is not selected, use gray filter on img, else no filter
  return (
    <div className="grid auto-rows-min border-r-2 grid-cols-[80%] gap-2 border-border-gray pt-4">
      {options.map((option, index) => (
        <button
          onClick={() => switchTab(option.link, index)}
          key={uniqid()}
          className={`font-chinese text-xl gap-x-2  flex items-center px-2 py-1 rounded ml-4 hover:brightness-90 whitespace-nowrap
             ${index === tabIndex ? "text-selected-sidebar bg-[#4376A9] " : "text-unselected-sidebar "} `}
        >
          <img
            src={option.icon}
            className={`w-8 h-8 ${index === tabIndex ? "filter-selected-sidebar-icon" : "filter-unselected-sidebar-icon"}`}
            alt="icon"
          />
          {option.text}
        </button>
      ))}
    </div>
  );
};

export default Sidebar;
